<template>
  <v-app
    id="login"
    class="brand_neutral"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg4
          >
            <v-flex
              class="mb-5"
            >
              <v-img
                style="margin: 0 auto;"
                width="200px"
                src="/img/logo_light_no_top.png"
              />
            </v-flex>
            <v-card class="elevation-1 pa-3">
              <v-card-title class="text-xs-center">
                <h1 class="flex mb-4 primary--text">
                  {{ $t('Console') }}
                </h1>

                <div class="absolute-right flag-login-position">
                  <language-switcher
                    flag-only
                    flag-size="24px"/>
                </div>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="model.username"
                    :label="$t('Login')"
                    append-icon="person"
                    name="login"
                    type="text"
                  />
                  <v-text-field
                    id="password"
                    v-model="model.password"
                    :label="$t('Password')"
                    append-icon="lock"
                    name="password"
                    type="password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link
                  :to="{
                    name: 'ForgotPassword',
                  }"
                  class="pl-2"
                >
                  {{ $t('Forgot Password?') }}
                </router-link>
                <v-spacer />
                <v-btn
                  :loading="loading"
                  color="primary"
                  @click="login"
                >
                  {{ $t('Login') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguageSwitcher from '../components/LanguageSwitcher'

export default {
  components: {
    LanguageSwitcher
  },

  data () {
    return {
      model: {
        username: '',
        password: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      loading: 'pagination/loading'
    })
  },

  methods: {
    login () {
      this.$store
        .dispatch('auth/AUTH_REQUEST', {
          $http: this.$http.make('auth:user'),
          user: this.model
        })
        .then(() => {
          this.$radio.$emit('app-login-success')
        })
        .catch((e) => {
          this.model.username = ''
          this.model.password = ''
          this.$radio.$emit('api-error', { message: `Login failed: ${e.message}` })
        })
    }
  }
}
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

a {
  text-decoration: none;
}
</style>
